import React from 'react'
import LogoWhite from 'assets/Logo'
import Button from 'material-ui/Button'
import Toolbar from 'material-ui/Toolbar'
import Hidden from 'material-ui/Hidden'
import IconButton from 'material-ui/IconButton'
import MenuIcon from 'material-ui-icons/Menu'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import { withStyles } from 'material-ui/styles'
import classNames from 'classnames'
import history from 'utils/history'

const styles = theme => ({
  root: {
    position: 'absolute',
    display: 'flex',
    right: 0,
    left: 0,
    zIndex: 1,
    padding: '5px 0',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.getContrastText(theme.palette.background.default),
  },
  toolbar: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
    position: 'fixed',
  },
  logo: {
    flexGrow: 1,
    marginLeft: 80,
    position: 'relative',
    display: 'flex',
    '& svg': {
      cursor: 'pointer',
    },
  },
  toolbarContent: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: 10,
      flexGrow: 0,
    },
  },
})

const Header = ({ isAuthentified, onToggleMenu, classes, className }) => (
  <div className={classNames(className, classes.root)}>
    <Toolbar disableGutters className={classes.toolbar}>
      <IconButton
        aria-label="open drawer"
        onClick={onToggleMenu}
        className={classNames(classes.menuButton)}
      >
        <MenuIcon />
      </IconButton>
      <div className={classes.toolbarContent}>
        <div className={classes.logo}>
          <LogoWhite height={50} onClick={() => history.push('/')} />
        </div>
        <Hidden xsDown>
          {!isAuthentified && (
            <Button component={Link} to="/login" color="contrast">
              Login
            </Button>
          )}
        </Hidden>
      </div>
    </Toolbar>
  </div>
)
Header.muiName = 'AppBar'

const mapStateToProps = state => ({
  isAuthentified: selectors.isAuthentified(state),
})

export default withStyles(styles)(connect(mapStateToProps, null)(Header))



// WEBPACK FOOTER //
// ./src/components/Header.js